import React from 'react';
import styled from 'styled-components/macro';
import Table from 'components/Table';
import { Group, WfDefinitionEngineTask } from 'models/response';
import { useTableColumns } from 'hooks/useTableColumns';
import utils from 'utils';

const Label = styled.p`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  margin-bottom: 10px;
`;

const Tables = styled.div<{ flexDirection?: string }>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
`;

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
`;

interface DocumentTablesProps {
  tasks: WfDefinitionEngineTask[];
  selectedDocument: any;
  selectedGroup: Group | null;
  onGroupSelection: (item: Group[]) => void;
  flexDirection?: string;
}

export const DocumentTables: React.FC<DocumentTablesProps> = ({
  tasks,
  selectedDocument,
  selectedGroup,
  onGroupSelection,
  flexDirection,
}) => {
  const t = utils.intl.useTranslator();
  const { tableColumnsGroup, tableColumnsUsers, tableColumnsTasks } = useTableColumns();

  return (
    <Tables flexDirection={flexDirection}>
      {tasks.length > 0 && (
        <TableWrapper>
          <Label>{t('Workflow Tasks')}</Label>
          <Table id="tasks-table" columns={tableColumnsTasks} rows={tasks} hasPagination hasSort hasFilter />
        </TableWrapper>
      )}
      {selectedDocument?.recipient && (
        <TableWrapper>
          <Label>{t('Groups')}</Label>
          <Table
            columns={tableColumnsGroup}
            rows={selectedDocument?.recipient}
            hasPagination
            hasSort
            hasFilter
            hasSelection
            onSelection={onGroupSelection}
            id="groups-table"
          />
        </TableWrapper>
      )}
      {selectedGroup?.groupUsers && (
        <TableWrapper>
          <Label>{t('Users')}</Label>
          <Table
            id="users-table"
            columns={tableColumnsUsers}
            rows={selectedGroup?.groupUsers}
            hasPagination
            hasSort
            hasFilter
          />
        </TableWrapper>
      )}
    </Tables>
  );
};
